import { Button } from "@mui/material";

const ArtifactButton = ({ text, variant, sx, onClick, isAI = false }) => {
  return (
    <Button
      sx={{
        ...sx,
        width: isAI ? "400px" : window.innerWidth <= 750 ? "250px" : "215px",
        height: isAI ? "40px" : window.innerWidth <= 750 ? "60px" : "70px",
        alignSelf: "center",
      }}
      variant={variant ? variant : "outlined"}
      onClick={onClick}
    >
      {text}
    </Button>
  );
};
export default ArtifactButton;
